export default __webpack_public_path__ + "static/media/notes.7ad571ee.svg";